import { IPeopleInfo } from '../interfaces/IPeopleInfo';

import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';

export default class PhonebookService {

  public static getPhonebook(url: string, token: string): Promise<IPeopleInfo[]> {
    return new Promise((resolve) => {
      if (token && url) {
        return new FetchProxy(url, {
          method: 'GET',
          credentials: 'same-origin',
          mode: 'cors',
          headers: new Headers({
            AuthToken: token
          })
        })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response: Response) => {
            if (!response.ok) return response.json();
            return response.json();
          })
          .then((phonebook: IPeopleInfo[]) => {
            resolve(phonebook);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        resolve(null);
      }
    });
  }
}
